<div [appTooltip]="value()" [position]="tooltipPosition()">{{ value() }}</div>
